<template>
    <div v-if="allowClose" @click="$emit('close')"></div>
    <div v-else></div>
    <dialog open>
        <header>
            <slot name="header">
                <h2>{{ title }}</h2>
            </slot>
        </header>
        <section>
            <slot></slot>
        </section>
        <section v-if="includeProgressBar">
					<progress class="progress is-info" max="100">100%</progress>
        </section>
        <menu>
            <slot name="actions">
                <button v-if="allowClose" class="button" @click="$emit('close')">Close</button>
            </slot>
        </menu>
    </dialog>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: false
        },
        allowClose: {
            type: Boolean,
            required: false
        },
        includeProgressBar: {
            type: Boolean,
            required: false
        }
    },
    emits: ['close']
}
</script>

<style scoped>
div {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.75);
  z-index: 10;
}

dialog {
  position: fixed;
  top: 20vh;
  left: 10%;
  width: 80%;
  z-index: 100;
  border-radius: 12px;
  border: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);
  padding: 0;
  margin: 0;
  overflow: hidden;
}

header {
  background-color: #a3567a;
  color: white;
  width: 100%;
  padding: 1rem;
}

header h2 {
  margin: 0;
}

section {
  background-color: rgb(248, 247, 247);
  padding: 1rem;
}

menu {
  background-color: rgb(248, 247, 247);
  padding: 1rem;
  display: flex;
  justify-content: flex-end;
  margin: 0;
}

@media (min-width: 768px) {
  dialog {
    left: calc(50% - 20rem);
    width: 40rem;
  }
}
</style>